import React from "react";
import { __ } from "@wordpress/i18n";
import { useLocation, Link } from "react-router-dom";
import MegaMenu from "../layouts/MegaMenu/MegaMenu";

// Import all the pages
import RestrictionsSettings from "../pages/RestrictionsSettings";
import RestrictionsCustomize from "../pages/RestrictionsCustomize";
import SecuritySaltChange from "../pages/SecuritySaltChange";
import SecurityErrorNotification from "../pages/SecurityErrorNotification";
import SecurityLoginSecurity from "../pages/SecurityLoginSecurity";
import SecurityPasswordPolicies from "../pages/SecurityPasswordPolicies";
import Security2faAuthentication from "../pages/Security2faAuthentication";
import Security2faList from "../pages/Security2faList";
import SecurityAdminPassword from "../pages/SecurityAdminPassword";
import SecurityRecaptcha from "../pages/SecurityRecaptcha";
import SecurityDisableRightClick from "../pages/SecurityDisableRightClick";
import SecurityEmailBlacklist from "../pages/SecurityEmailBlacklist";
import SecurityAddressBlacklist from "../pages/SecurityAddressBlacklist";
import SecurityAPIPrivacy from "../pages/SecurityAPIPrivacy";
import SecurityRecommendations from "../pages/SecurityRecommendations";
// import SecurityAdminEmails from "../pages/SecurityAdminEmails";
import SecurityUpdates from "../pages/SecurityUpdates";
import SecurityComments from "../pages/SecurityComments";
import SecurityCloudflareTurnstile from "./SecurityCloudflareTurnstile/SecurityCloudflareTurnstile";
import SecurityLoginLimit from "./SecurityLoginLimit";
import LoginTemporaryLoginCreate from "../pages/LoginTemporaryLoginCreate";
import LoginTemporaryLoginSettings from "../pages/LoginTemporaryLoginSettings";
import LoginTemporaryLoginExpress from "../pages/LoginTemporaryLoginExpress";
import LoginActionLoginSettings from "../pages/LoginActionLoginSettings";
import LoginActionLogin from "../pages/LoginActionLogin";
import LoginActionLoginAutomations from "../pages/LoginActionLoginAutomations";
import MoreReset from "../pages/MoreReset";
import MoreStatus from "../pages/MoreStatus";
import MoreExtra from "./MoreExtra";
import OtherPlugin from "../pages/other-plugins/index";

const Settings = () => {
  const location = useLocation();
  const pathname = location.pathname;
  
  // Component mapping - associates paths with their components
  const ROUTE_COMPONENT_MAP = {
    // Restrictions pages
    "/restrictions/settings": RestrictionsSettings,
    "/restrictions/customize": RestrictionsCustomize,
    
    // Security pages
    "/security/salt_change": SecuritySaltChange,
    "/security/secure-your-data/disable_right_click": SecurityDisableRightClick,
    "/security/secure-your-data/email_blacklist": SecurityEmailBlacklist,
    "/security/secure-your-data/address_blacklist": SecurityAddressBlacklist,
    
    // Login pages
    "/login/temporary-login": LoginTemporaryLoginCreate,
    "/login/temporary-login/create": LoginTemporaryLoginCreate,
    "/login/temporary-login/settings": LoginTemporaryLoginSettings,
    "/login/temporary-login/express_login": LoginTemporaryLoginExpress,
    "/login/active-logins/settings": LoginActionLoginSettings,
    "/login/active-logins/active_logins": LoginActionLogin,
    "/login/active-logins/automations": LoginActionLoginAutomations,
    "/login/login_security/login_security": SecurityLoginSecurity,
    "/login/login_security/password_policies": SecurityPasswordPolicies,
    "/login/login_security/2fa_authentication": Security2faAuthentication,
    "/login/login_security/2fa_list": Security2faList,
    "/login/login_security/use_admin_password": SecurityAdminPassword,
    "/login/login_security/re_captcha": SecurityRecaptcha,
    "/login/login_security/cloudflare_turnstile": SecurityCloudflareTurnstile,
    "/login/login_security/login_limit": SecurityLoginLimit,
    
    // More pages
    "/more/reset": MoreReset,
    "/more/error-notification": SecurityErrorNotification,
    "/more/log/status": MoreStatus,
    "/more/misc/api_privacy": SecurityAPIPrivacy,
    "/more/misc/recommendations": SecurityRecommendations,
    // "/more/misc/admin_emails": SecurityAdminEmails,
    "/more/misc/comments": SecurityComments,
    "/more/misc/updates": SecurityUpdates,
    "/more/extra": MoreExtra,
    // Other plugins
    "/other-plugin": OtherPlugin,
  };
  
  const renderContent = () => {
    // Look up the component for the current path
    const Component = ROUTE_COMPONENT_MAP[pathname];
    
    // If a component is found, render it, otherwise show SettingsNotFound
    return Component ? <Component /> : <SettingsNotFound />;
  };

  return (
    <>
      <div className="row">
        <div className="col-3" style={{ width:"20%" }}>
          <MegaMenu />
        </div>
        <div className="col-9" style={{ width:"80%" }}>
          {renderContent()}
        </div>
      </div>
    </>
  );
};

// Not found component for settings
const SettingsNotFound = () => (
  <div>
    <h2>{__("Setting Not Found", "ultimate-security")}</h2>
    <p>{__("The setting you are looking for does not exist.", "ultimate-security")}</p>
    <Link to="/settings">{__("Go back to Settings", "ultimate-security")}</Link>
  </div>
);

export default Settings;